module.exports = __webpack_public_path__ + "static/media/20x30no2.69bc9b15.jpg";